import { useNavigate, useLocation } from 'react-router-dom'
import { useAuthStore } from '@/stores/authStore'

interface TopBarProps {
  title?: string
  leftIcon?: React.ReactNode
  rightIcon?: React.ReactNode
}

const pageTitles: Record<string, string> = {
  '/dashboard': 'Kegiatan',
  '/laporan': 'Laporan',
  '/pimpinan': 'Pimpinan',
  '/settings': 'Profil',
  '/stadion': 'Dashboard Stadion',
  '/program-kerja': 'Program Kerja',
}

// Halaman utama yang back button nya ke login
const mainPages = ['/dashboard', '/stadion', '/laporan', '/settings', '/program-kerja']

export default function TopBar({ leftIcon, rightIcon }: TopBarProps) {
  const navigate = useNavigate()
  const location = useLocation()
  const logout = useAuthStore((s) => s.logout)

  const title = pageTitles[location.pathname] || 'ISWARA PW Jawa Timur'

  const isMainPage = mainPages.some(page => location.pathname === page || location.pathname.startsWith(page + '/'))

  const handleBack = () => {
    if (isMainPage) {
      logout()
      navigate('/login', { replace: true })
    } else {
      navigate(-1)
    }
  }

  return (
    <header className="fixed top-0 left-0 right-0 z-50 bg-primary shadow-topbar">
      <div className="max-w-2xl mx-auto h-14 flex items-center justify-between px-4">
        <div className="w-10 flex items-center justify-start">
          {leftIcon || (
            <button
              onClick={handleBack}
              className="text-white/80 hover:text-white transition-colors p-1"
              title={isMainPage ? 'Logout' : 'Kembali'}
            >
              {isMainPage ? (
                <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1" />
                </svg>
              ) : (
                <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
                </svg>
              )}
            </button>
          )}
        </div>

        <h1 className="text-white font-bold text-base truncate">{title}</h1>

        <div className="w-10 flex items-center justify-end">
          {rightIcon || null}
        </div>
      </div>
    </header>
  )
}
